import React, {useState} from 'react';

//styles
import './Footer.scss'

import {images} from "../../constants";
import {AppWrap, MotionWrap} from "../../wrapper";
import {client} from "../../client";

const Footer = () => {
    const [formDate, setFormData] = useState({
        name: '',
        message: '',
        email: ''
    })
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const {name, message, email} = formDate

    const handleChangeInput = (e) => {
        const {name, value} = e.target;

        setFormData({...formDate, [name]: value})
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true);

        const contact = {
            _type: 'contact',
            name: name,
            email: email,
            message: message
        }

        client.create(contact)
            .then(() => {
                setLoading(false)
                setIsFormSubmitted(true)
            })
    }

    return (
        <>
            <h2 className="head-text">Contact me</h2>

            <div className="app__footer-cards">

                <div className="app__footer-card">

                    <img src={images.email} alt="email"/>

                    <a href="mailto:moa.mm996@gmail.com"
                       className="p-text"
                    >
                        moa.mm996@gmail.com
                    </a>

                    {/**telefon**/}

                </div>
                <div className="app__footer-card">

                    <img src={images.mobile} alt="email"/>

                    <a href="tel:+4792346407"
                       className="p-text"
                    >
                        +4792346407
                    </a>

                    {/**telefon**/}

                </div>
            </div>

            {!isFormSubmitted ? (


                < div className="app__footer-form app__flex">
                    < div className="app__flex">
                        <input
                            type="text"
                            className="p-text"
                            placeholder="Your Name"
                            onChange={handleChangeInput}
                            name="name"
                            value={name}

                        />

                    </div>

                    <div className="app__flex">
                        <input
                            type="email"
                            className="p-text"
                            placeholder="Email"
                            onChange={handleChangeInput}
                            name="email"
                            value={email}

                        />

                    </div>

                    <div className="app__flex">
                <textarea
                    name="message"
                    cols="30"
                    rows="10"
                    placeholder="Your Message"
                    value={message}
                    onChange={handleChangeInput}
                />

                    </div>

                    <button type="button" className="p-text" onClick={handleSubmit}>
                        {loading ? 'Sending...' : 'Send Message'}
                    </button>

                </div>
            ) : (
                <div>
                    <h3>Thank You for getting in touch!</h3>
                </div>
            )}

        </>
    )
}
export default AppWrap(
    MotionWrap(Footer, 'app__footer'),
    "contact",
    'app__whitebg'
);